import React from 'react';
import PropTypes from 'prop-types';
import {
  getDaysFromNow,
  formFullAddress,
  toLocalDateTimeFormat,
  translateEnquiryStatus
} from 'utilities/helper.util';
import { zoomToFeature } from 'components/Map/helper';
import {
  ZoomIn24,
  View24,
  ViewOff16,
  WatsonHealthSubVolume24,
  Automatic16
} from '@carbon/icons-react';
import { StatusIcon } from 'components';

const PopUp: React.FC<Props> = (props) => {
  const { attributes, onButtonClick, extent, selectedFeatureExtent } = props;
  const handleButtonClick = () => {
    if (attributes?.objectid && typeof onButtonClick === 'function') {
      const isDataRotated =
        getDaysFromNow(attributes.enquiry_at) >=
        Number(process.env.REACT_APP_SENTINEL_DATA_ROTATION_DAYS);
      onButtonClick(
        attributes.objectid,
        isDataRotated,
        !!attributes.is_limit_reached
      );
    }
  };

  const handleZoomIn = (extent: any) => {
    extent && zoomToFeature(extent, 0, true);
    window.loadedView.popup.close();
  };

  const handleNextFeature = () => {
    window.loadedView.popup.next();
  };

  const featureCount = window.loadedView?.popup?.featureCount;

  return (
    <div className="history-page-map-popup-container">
      {attributes && (
        <>
          <div className="history-page-map-popup-content">
            <div className="header-container">
              <div className={`title ${attributes.status.toLowerCase()}`}>
                Job {attributes.external_id}
              </div>
              <div className="auto-renew-icon">
                {!attributes.archived_at &&
                  attributes.auto_renew !== undefined &&
                  attributes.auto_renew !== 0 &&
                  attributes.auto_renew !== false && <Automatic16 />}
              </div>
            </div>
          </div>
          <div className="history-page-map-popup-content">
            <div className="status-controls-container">
              {attributes.is_limit_reached ? (
                <div className="status over-trans-limit">
                  <ViewOff16 />
                  Unable to view
                </div>
              ) : (
                <div className="status">
                  <StatusIcon status={attributes.status} />{' '}
                  {translateEnquiryStatus(
                    attributes.status,
                    attributes.archived_at,
                    false,
                    false
                  )}
                </div>
              )}
              <div className="controls">
                <div
                  className="control"
                  onClick={() =>
                    handleZoomIn(extent || selectedFeatureExtent.current)
                  }
                >
                  <ZoomIn24 />
                </div>
                <div className="control" onClick={handleButtonClick}>
                  <View24 />
                </div>
                {featureCount && featureCount > 1 && (
                  <div className="control" onClick={handleNextFeature}>
                    <WatsonHealthSubVolume24 />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="history-page-map-popup-content">
            <div className="info-list">
              <div>{attributes.user_reference}</div>
              <div>
                {formFullAddress(attributes.address?.split('@@') || [])}
              </div>
              <div>{toLocalDateTimeFormat(attributes.enquiry_at)}</div>
            </div>
          </div>
        </>
      )}
      {!attributes && 'No attributes received'}
    </div>
  );
};

const propTypes = {
  isFullSet: PropTypes.bool,
  attributes: PropTypes.any,
  extent: PropTypes.any,
  selectedFeatureExtent: PropTypes.any,
  onButtonClick: PropTypes.func
};

type Props = PropTypes.InferProps<typeof propTypes>;

PopUp.defaultProps = {
  attributes: null
};

export default PopUp;

export const PopUpOutFields = [
  'objectid',
  'status',
  'external_id',
  'user_full_name',
  'user_email_name',
  'user_reference',
  'address',
  'created_at',
  'completed_referral_count',
  'total_referral_count',
  'archived_at'
];
